export const getImageBreakpointUrl = (currentBreakpoint: string = 'sm', image) => {
  if (!image) return null;
  let format = 'small';
  switch (currentBreakpoint) {
    case 'xs':
    default:
      format = 'small';
      break;
    case 'sm':
    case 'md':
      format = 'medium';
      break;
    case 'lg':
    case 'xl':
      format = 'large';
      break;
  }
  if (!image.formats || !image.formats[format]) {
    return image;
  }
  return image.formats ? image.formats[format] : image;
};
